// Core
import React, { useEffect, useRef } from 'react';
import {
  useColorModeValue,
  useDisclosure
} from '@chakra-ui/react';

// Assets
import { hexToRgba, drawCircleOnMap } from 'services/Utils';

export default function MapWithPoints({ data, item, borderRadius, height }) {
  const mapRef = useRef(null);
  const markersRef = useRef([]);
  const mapTheme = useColorModeValue('mapbox://styles/mapbox/light-v11', 'mapbox://styles/mapbox/dark-v11');

  useEffect(() => {
    if (!window.mapboxgl || mapRef.current) { return; }

    window.mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
    const map = new window.mapboxgl.Map({
      container: 'map-single',
      style: mapTheme,
      center: [data[0]?.long || 0, data[0]?.lat || 0],
      zoom: data[0]?.name === 'Australia' ? 3 : data?.length === 1 ? 13 : 6,
    });

    data.forEach((point) => {
      const el = document.createElement('div');
      el.className = 'marker';
      el.style.transition = 'none';
      el.style.width = '64px';
      el.style.height = '64px';
      el.style.borderRadius = '50%';
      //el.style.border = '3px solid #2ABDFD';
      el.style.display = 'flex';
      el.style.alignItems = 'center';
      el.style.justifyContent = 'center';
      el.style.fontWeight = 'bold';
      el.textContent = '';

      const iconHtml = `
        <img src="${item?.image}" 
          style="background-size: cover; width: 51px; height: 51px; 
          position: absolute; border-radius: 50px;
          margin-top: -20px;
          background-position: center center; background-repeat: no-repeat">
        <svg width="64" height="84" viewBox="0 0 64 84" fill=${item?.categories[0]?.color || '#1E7735'}>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M32 0C49.6731 0 64 14.3269 64 32C64 34.1572 63.7865 36.2646 63.3796 38.3021C60.5552 59.5859 32.1682 83.8095 32.1682 83.8095C32.1682 83.8095 8.01051 63.195 2.04885 43.2909C0.724581 39.7797 0 35.9745 0 32C0 14.3269 14.3269 0 32 0Z" 
          stroke-width="0px"
          stroke="#FFF"
          fill=${item?.categories[0]?.color || '#1E7735'}/>
        </svg>
      `;

      el.innerHTML = iconHtml;

      const marker = new window.mapboxgl.Marker(el).setLngLat([point.long, point.lat]).addTo(map);
      markersRef.current.push(marker);

      el.addEventListener('click', () => {
        const currentZoom = map.getZoom();
        map.flyTo({
          center: [point.long, point.lat],
          zoom: currentZoom + 2,
          speed: 1.5,
          curve: 1.2,
        });
      });
    });

    return () => map.remove();
  }, [data]);

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.setStyle(mapTheme);
    }
  }, [mapTheme]);

  return <div id="map-single" style={{ height, width: '100%', borderRadius }} />;
}
